<div class="datetime-picker">
  <div class="datetime-picker__date" #trigger>
    <mat-form-field appearance="fill" class="datetime-field" (click)="toggleCalendar()">
      <mat-label>{{ label }}</mat-label>
      <input
        matInput
        [value]="dateDisplay"
        readonly
        placeholder="Select date"
        [disabled]="disabled"
        (keydown.enter)="toggleCalendar()"
        data-testId="datetime-picker-date">
      <mat-icon matSuffix class="datetime-field__icon">calendar_today</mat-icon>
    </mat-form-field>
  </div>

  <app-time-field
    class="datetime-picker__time"
    [label]="timeLabel"
    [time]="selectedTime"
    [disabled]="disabled"
    (timeChange)="onTimeChange($event)">
  </app-time-field>
</div>

<!-- Fixed-position calendar rendered outside the dialog flow -->
<div class="dtp-popup-container" *ngIf="showPopup"
  [ngStyle]="popupStyle"
  (mousedown)="$event.stopPropagation()"
  (click)="$event.stopPropagation()">
  <div class="dtp-header">
    <button mat-icon-button type="button" (click)="prevMonth()" aria-label="Previous month">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <span class="dtp-header__title">{{ monthYearLabel }}</span>
    <button mat-icon-button type="button" (click)="nextMonth()" aria-label="Next month">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  <div class="dtp-calendar">
    <div class="dtp-calendar__weekdays">
      <span *ngFor="let d of weekDays" class="dtp-calendar__weekday">{{ d }}</span>
    </div>
    <div class="dtp-calendar__grid">
      <button
        *ngFor="let cell of calendarCells"
        type="button"
        class="dtp-calendar__day"
        [class.dtp-calendar__day--other]="!cell.currentMonth"
        [class.dtp-calendar__day--selected]="cell.selected"
        [class.dtp-calendar__day--today]="cell.today"
        (click)="selectDay(cell)">
        {{ cell.day }}
      </button>
    </div>
  </div>

  <!-- Optional extra controls supplied by the host (e.g. window size, time zone) -->
  <div class="dtp-extra">
    <ng-content select="[dtp-extra]"></ng-content>
  </div>
</div>
